import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import Item from './quickLaunchDropdownItem'

import styles from './quickLaunchDropdown.scss'

import BetaLabel from 'assets/components/main_topbar/beta-label.svg'
import OEQIcon from 'assets/global/slide_icons/open-ended-question.svg'
import DrawItIcon from 'assets/global/slide_icons/draw-it.svg'
import TimerIcon from 'assets/global/slide_icons/timer-icon.svg'
import CollaborateIcon from 'assets/global/slide_icons/collaborate-icon.svg'

class QuickLaunchDropdown extends PureComponent {

	getItems = () => {
		const items = [
			{
				icon: OEQIcon,
				text: localize('global_slides_oeq'),
				shouldShow: this.props.shouldShowQuickLaunchOeq,
				onClick: this.props.onOeqSelection,
			},
			{
				icon: DrawItIcon,
				text: localize('global_slides_drawIt'),
				shouldShow: this.props.shouldShowQuickLaunchDrawIt,
				onClick: this.props.onDrawItSelection,
			},
			{
				icon: TimerIcon,
				text: localize('global_slides_timer'),
				shouldShow: this.props.shouldShowQuickLaunchTimer,
				onClick: this.props.onTimerSelection,
			},
			{
				icon: CollaborateIcon,
				text: localize('global_slides_collaborateBoard'),
				shouldShow: this.props.shouldShowQuickLaunchCollaborate,
				onClick: this.props.onCollaborateSelection,
			},
		]

		return items
			.filter(({ shouldShow }) => shouldShow === true)
			.map(({ icon, text, secondaryIcon, onClick }, key) => <Item
				key={key}
				icon={icon}
				text={text}
				secondaryIcon={secondaryIcon}
				onClick={onClick}
			/>)
	}

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='title'>
					<h2 styleName='title-text'>
						{localize('topbar_quicklaunch_title')}
					</h2>
					<Isvg
						src={BetaLabel}
						cacheGetRequests={true}
						styleName='title-label'
					/>
				</div>

				<ul styleName='list'>
					{this.getItems()}
				</ul>
			</div>
		)
	}
}

QuickLaunchDropdown.defaultProps = {
	shouldShowQuickLaunchOeq: false,
	shouldShowQuickLaunchDrawIt: false,
	shouldShowQuickLaunchTimer: false,
	shouldShowQuickLaunchFieldTrip: false,
	shouldShowQuickLaunchCollaborate: false,
	onDrawItSelection: () => {},
	onCollaborateSelection: () => {},
	onOeqSelection: () => {},
	onTimerSelection: () => {},
}

QuickLaunchDropdown.propTypes = {
	shouldShowQuickLaunchOeq: PropTypes.bool,
	shouldShowQuickLaunchDrawIt: PropTypes.bool,
	shouldShowQuickLaunchTimer: PropTypes.bool,
	shouldShowQuickLaunchFieldTrip: PropTypes.bool,
	shouldShowQuickLaunchCollaborate: PropTypes.bool,
	onDrawItSelection: PropTypes.func,
	onCollaborateSelection: PropTypes.func,
	onOeqSelection: PropTypes.func,
	onTimerSelection: PropTypes.func,
}

export default CSSModules(QuickLaunchDropdown, styles, {allowMultiple: true})
